// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"6d90d50c","453":"a535763d","667":"cbb308a7"}[chunkId] + ".chunk.js";
};